<template>
  <path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="1.8" />
</template>
